.githubWrapper {
  color: var(--white);
  position: absolute;
  top: 0;
  border: 0;
  right: 0;
  fill: var(--primaryColor);
  height: 40px;
  width: 40px;
}
